













































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ROUTE_ALPACA } from '@/router';
import { Alpaca } from '@/backend/type';
import { bgShadowMap } from '@/utils/color';
import { alpaUnit } from '@/utils/unit';
import BigNumber from 'bignumber.js';
import { getAlpaca } from '@/utils/web3';

@Component
export default class AlpacaCard extends Vue {
  @Prop({
    required: true,
  })
  public alpaca!: Alpaca;

  @Prop({
    required: false,
    default: true,
  })
  public hasInfo!: boolean;

  @Prop({
    required: false,
    default: true,
  })
  public hasState!: boolean;

  @Prop({
    required: false,
    default: true,
  })
  public hasShadow!: boolean;

  @Prop({
    required: false,
    default: false,
  })
  public hasBreedingFee!: boolean;

  @Prop({
    required: false,
    default: false,
  })
  public hasSelect!: boolean;

  @Prop({
    required: false,
    default: false,
  })
  public selected!: boolean;

  @Prop({
    required: false,
    default: true,
  })
  public hasLink!: boolean;

  public breedingFee: BigNumber | '-' = '-';

  get bgColor() {
    return this.alpaca.card_background_color;
  }

  get offsetY() {
    return this.alpaca.card_offset ? `16px` : `0px`;
  }

  get shadowColor() {
    return bgShadowMap.get(this.bgColor) || '#82C4B4';
  }

  get isEgg() {
    return this.alpaca && this.alpaca.state === 0;
  }

  get isFarmer() {
    return this.alpaca && this.alpaca.shepherd === process.env.VUE_APP_MASTER_CHEF_CONTRACT_ADDRESS;
  }

  get isSquad() {
    return this.alpaca && this.alpaca.shepherd === process.env.VUE_APP_ALPACA_SQUAD_CONTRACT_ADDRESS;
  }

  get router() {
    if (this.hasLink) {
      return { name: ROUTE_ALPACA, params: {alpacaID: this.alpaca.id}};
    }
    return '';
  }

  get account() {
    return this.$store.getters.getAccount;
  }

  public async getBreedFees() {
    if (this.hasBreedingFee) {
      const info = await getAlpaca(Number(this.alpaca.id));
      if (info) {
        this.breedingFee = alpaUnit(new BigNumber(info.hatchingCost).multipliedBy(info.hatchingCostMultiplier));
      }
    }
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getBreedFees();
    }
  }
}
